import { Button, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap"
import { useTranslation } from "react-i18next"

const getDepartmentValue = (department) => {
    if (typeof department === 'string') {
        return department
    }

    return department?.code || department?.name || department?._id || ''
}

const normalizeDepartments = (departments = []) => {
    return departments
        .map(getDepartmentValue)
        .map(department => String(department || '').trim().toUpperCase())
        .filter(Boolean)
}

export default function UserForm({ state, handleInputChange, submit, isAddingOrEditing, isRegistering, disableEnableUsers, departments, handleDepartmentToggle }) {
    const { t } = useTranslation()
    const selectedDepartments = normalizeDepartments(state.departments || [])

    return (
        <Form onSubmit={submit} className="px-4 formulario">
            <Row>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>{t('admin.users.username')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='username'
                        value={state.username || ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>
                        {t('admin.users.password')} *&nbsp;
                        {isAddingOrEditing === 'editing' &&
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                    <Tooltip>
                                        {t('admin.users.passwordTooltip')}
                                    </Tooltip>
                                }
                            >
                                <i className="fas fa-info-circle"></i>
                            </OverlayTrigger>
                        }
                    </Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='password'
                        name='password'
                        value={state.password || ''}
                        onChange={handleInputChange}
                        autoComplete="new-password"
                        required={isAddingOrEditing === 'adding' ? true : false}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>{t('admin.users.email')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='email'
                        value={state.email || ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>{t('admin.users.rol')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        as="select"
                        name="rol"
                        value={state.rol || ''}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="department">{t('admin.users.department')}</option>
                        <option value="commercial">{t('admin.users.commercial')}</option>
                        <option value="admin">{t('admin.users.admin')}</option>
                    </Form.Control>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className="my-2">
                    <Form.Label>{t('admin.users.department')}</Form.Label>
                    <div className="d-flex flex-wrap gap-3">
                        {departments.map((department) => {
                            const departmentValue = String(getDepartmentValue(department) || '').trim().toUpperCase()

                            return (
                                <Form.Check
                                    key={department._id || departmentValue}
                                    type="checkbox"
                                    label={department.name || departmentValue}
                                    checked={selectedDepartments.includes(departmentValue)}
                                    onChange={() => handleDepartmentToggle(departmentValue)}
                                />
                            )
                        })}
                    </div>
                </Col>
            </Row>
            <Row className="my-2">
                <Col xs={6}>
                    {isAddingOrEditing === 'editing' && (
                        <Button variant="secondary" className="my-2" onClick={(e) => disableEnableUsers(e)}>
                            {state?.active
                                ?
                                <><i className="fas fa-ban me-2"></i> {t('global.disable')}</>
                                :
                                <><i className="fas fa-check me-2"></i> {t('global.enable')}</>
                            }
                        </Button>
                    )}
                </Col>
                <Col xs={6} className="d-flex justify-content-end">
                    <Button variant='primary' type="submit" className="my-2">
                        {isRegistering
                            ?
                            <>
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                            :
                            isAddingOrEditing === 'editing'
                                ?
                                <><i className="fas fa-edit me-2"></i> {t('global.edit')}</>
                                :
                                <><i className="fas fa-user-plus me-2"></i> {t('global.register')}</>
                        }
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}
